import React, { FC, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import { useLocation } from '@reach/router';

import Loader from '@bitcoin-portal/bitcoincom-pkg-components/dist/Loader';

import { Wrapper, CustomContentBlock } from './styled';
import LoadingStatus from './Statuses/Loading';
import SuccessStatus from './Statuses/SuccessStatus';
import Pending from './Statuses/Pending';
import Failed from './Statuses/Failed';

const ThankYouPage: FC<{ content: Queries.ThankYouPageQuery }> = ({
  content,
}) => {
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();

  const [txid, setTxId] = useState<string>();
  const [status, setStatus] = useState<string>();

  useEffect(() => {
    const urlParams = new URLSearchParams(search);

    if (urlParams.has('transactionId') && urlParams.has('transactionStatus')) {
      setTxId(urlParams.get('transactionId') || undefined);
      setStatus(urlParams.get('transactionStatus') || undefined);
      setLoading(false);
    }
  }, [search]);

  /* useEffect(() => {
    if (!txid) return;
    const getTransactionInfo = async () => {
      try {
        type MoonpayResponse = {
          quoteCurrencyAmount: number;
          currencyId: string;
        };

        const moonpayApiKey = 'pk_live_1mznzoMjSucjhoEpiSAPL8lDDu8sNr';
        const moonpayEndpoint = 'https://api.moonpay.com/v1/transactions/';

        const txurl = `${moonpayEndpoint}${txid}`;

        const { data } = await axios.get<MoonpayResponse>(txurl, {
          params: {
            apiKey: moonpayApiKey,
          },
        });

        const { quoteCurrencyAmount, currencyId } = data;
        console.log(`quoteCurrencyAmount: ${quoteCurrencyAmount}`);
        console.log(`currencyId: ${currencyId}`);

        // Iterate over currencies
        let currencyName = '';
        let currencyCode = '';
        for (let i = 0; i < moonpayCurrencies.length; i += 1) {
          if (moonpayCurrencies[i].id === currencyId) {
            currencyName = moonpayCurrencies[i].name;
            currencyCode = moonpayCurrencies[i].code;
            break;
          }
        }

        console.log(currencyName, currencyCode);
        // setCurrency({ currencyName, currencyCode });
      } catch (error) {
        console.log('error getting mp data', error);
      }
    };

    getTransactionInfo();
  }, [txid, status]); */

  return (
    <Wrapper>
      <main>
        <CustomContentBlock>
          {loading ? (
            <Loader />
          ) : (
            <>
              {txid && status === 'completed' && (
                <SuccessStatus
                  txid={txid}
                  status={status}
                  content={content.file?.childJson?.content || null}
                  links={content.file?.childJson?.links || null}
                />
              )}
              {txid && status === 'pending' && (
                <LoadingStatus
                  txid={txid}
                  status={status}
                  content={content.file?.childJson?.content || null}
                  links={content.file?.childJson?.links || null}
                />
              )}
              {txid && status === 'failed' && (
                <Failed
                  txid={txid}
                  status={status}
                  failed={content.file?.childJson?.failed || null}
                  content={content.file?.childJson?.content || null}
                  links={content.file?.childJson?.links || null}
                />
              )}
              {txid &&
                status &&
                status !== 'pending' &&
                status !== 'completed' &&
                status !== 'failed' && (
                  <Pending
                    txid={txid}
                    status={status}
                    failed={content.file?.childJson?.failed || null}
                    content={content.file?.childJson?.content || null}
                    links={content.file?.childJson?.links || null}
                    pending={content.file?.childJson?.pending || null}
                  />
                )}
            </>
          )}
        </CustomContentBlock>
      </main>
    </Wrapper>
  );
};

export const query = graphql`
  fragment ThankYouCommon on Json {
    content {
      title
      image {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageAlt
      description
      checkYourEmail
      moreInfoSuccess
      labels {
        transaction
        status
      }
      friends
    }

    links {
      support {
        title
        url
      }
      faq {
        title
        url
      }
    }
  }
`;

export default ThankYouPage;
